// extracted by mini-css-extract-plugin
module.exports = {"Tick":"Tick--1c58f","LegendItem":"LegendItem--NS1Ez"};